import React from 'react'

const Pagination = ({offset, limit, totals, currentPage, OnClickPaginate}) => {
  const pageMax = totals > 0 ? Math.ceil(totals/limit) : 1
  const cur = currentPage === 0 ? 1 : currentPage
  let page = 1
  let pageList = []

  if(totals > 0){
    pageList.push(page)
    while(offset + limit*page < totals && page < pageMax){
      page++
      pageList.push(page)
    }
  }

  // Ne pas afficher la pagination s'il n'y a qu'une seule page
  if (pageMax <= 1) {
    return null
  }

  return (
    <nav className="pagination" aria-label="Navigation des pages">
      <ul className="pagination-list" role="list">
        {cur > 1 && (
          <li className="pagination-item pagination-prev-first">
            <a 
              href="./" 
              data-num-page="1" 
              onClick={OnClickPaginate}
              aria-label="Aller à la première page"
            > 
              &lt;&lt; 
            </a>
          </li>
        )}
        {cur > 1 && (
          <li className="pagination-item pagination-prev">
            <a 
              href="./" 
              data-num-page={cur-1 > 0 ? cur-1 : 1} 
              onClick={OnClickPaginate}
              aria-label="Aller à la page précédente"
            > 
              &lt; 
            </a>
          </li>
        )}
        {pageList.map((p, index) => {
          const isCurrentPage = (p === 1 && currentPage === 0) || p.toString() === currentPage.toString()
          return (
            <li 
              className={`pagination-item${isCurrentPage ? ' current' : ''}`} 
              key={index}
            >
              <a 
                href="./" 
                data-num-page={p} 
                onClick={OnClickPaginate}
                aria-current={isCurrentPage ? 'page' : undefined}
                aria-label={isCurrentPage ? `Page ${p}, page actuelle` : `Aller à la page ${p}`}
              >
                {p}
              </a>
            </li>
          )
        })}
        {cur < pageMax && (
          <li className="pagination-item pagination-next">
            <a 
              href="./" 
              data-num-page={cur > 0 ? cur+1 : cur+2} 
              onClick={OnClickPaginate}
              aria-label="Aller à la page suivante"
            > 
              &gt; 
            </a>
          </li>
        )}
        {cur < pageMax && (
          <li className="pagination-item pagination-next-last">
            <a 
              href="./" 
              data-num-page={pageMax} 
              onClick={OnClickPaginate}
              aria-label="Aller à la dernière page"
            > 
              &gt;&gt; 
            </a>
          </li>
        )}
      </ul>
    </nav>
  )
}

export default Pagination
